import { v4 as uuid } from 'uuid';

// per-browser-profile id, distinct from Electron's device-level machine-id
const INSTALLATION_ID_KEY = 'coscientist_installation_id';
// per-tab id; engagement-session bucketing happens later in Mode SQL
const SESSION_ID_KEY = 'coscientist_analytics_session_id';

let installationId: string | null = null;
let analyticsSessionId: string | null = null;

function getOrCreate(getStorage: () => Storage, key: string): string {
  try {
    // can throw: private mode, blocked cookies, SSR
    const storage = getStorage();
    const existing = storage.getItem(key);
    if (existing) return existing;
    const created = uuid();
    storage.setItem(key, created);
    return created;
  } catch {
    return uuid();
  }
}

export function getInstallationId(): string {
  if (installationId == null) {
    installationId = getOrCreate(
      () => window.localStorage,
      INSTALLATION_ID_KEY,
    );
  }
  return installationId;
}

export function getAnalyticsSessionId(): string {
  if (analyticsSessionId == null) {
    analyticsSessionId = getOrCreate(
      () => window.sessionStorage,
      SESSION_ID_KEY,
    );
  }
  return analyticsSessionId;
}

export function getChannel(): string {
  // mirrors Electron's channel field; $rails_env beats hostname sniffing for reliability
  return window.$rails_env === 'production' ? 'production' : 'development';
}
